import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { createTicketGridTemplate } from "../thunks/createTicketGridTemplate";
import { getTicketGridChildTemplates } from "../thunks/getTicketGridChildTemplates";
import { ITicketGridsState } from "../types/ITicketGridsState";

export const addCreateTicketGridTemplate = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(createTicketGridTemplate.pending, (state) => {
    state.ticketGridsCreating = true;
  });
  builder.addCase(createTicketGridTemplate.rejected, (state, action) => {
    state.ticketGridsCreating = false;
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка создания билетной сетки! "${action.meta.arg.name}": ${action.error.message}`,
    };
    state.errors = state.errors ? [...state.errors, error] : [error];
  });
  builder.addCase(createTicketGridTemplate.fulfilled, (state, action) => {
    if (action.payload.reportID) {
      state.updated = [
        ...state.updated,
        {
          id: action.payload.reportID,
          message: `Билетная сетка "${action.meta.arg.name}" успешно создана`,
        },
      ];
      state.parentId = action.payload.reportID;
    }
    state.ticketGridsCreating = false;
  });
};

export const addGetTicketGridChildTemplates = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(getTicketGridChildTemplates.pending, (state) => {
    state.loadingChildTemplates = true;
  });
  builder.addCase(getTicketGridChildTemplates.rejected, (state, action) => {
    state.loadingChildTemplates = false;
    if (
      action.error.message !== "Aborted" &&
      action.error.name !== "TypeError"
    ) {
      const error: IActionErrorInfo = {
        id: Date.now(),
        message: `Не удалось получить список шаблонов!: ${action.error.message}`,
      };
      state.errors = [...state.errors, error];
    }
  });
  builder.addCase(getTicketGridChildTemplates.fulfilled, (state, action) => {
    state.loadingChildTemplates = false;
    state.parentId = action.meta.arg;
    state.childTemplates = [...action.payload];
  });
};
